import React from 'react';
import ModalBasic from '../../../../pages/component/ModalBasic';
import ValidationText from '../../../../utils/validation/ValidationText';
import DropdownSelect from '../../../dropdown/Dropdown';
import TextInput from '../../../UIComponent/TextInput';
import DatePicker from '../../../datePicker/DatePicker';
import moment from "moment";

function AddEditProject(props) {
    return (
        <ModalBasic
            id="show-Add-edit-project-modal"
            modalOpen={props.addEditModel}
            setModalOpen={props.setOpenModal}
        >
            <div className="bg-white px-10 py-6 rounded-lg">
                <h1 className="text-3xl text-[#c00000] font-bold leading-loose py-4 mt-[-3rem]">
                    {props.editingProject ? "Edit Project" : "Add Project"}
                </h1>

                <div className="grid grid-cols-12 gap-6 w-full">
                    <div className="col-span-12 md:col-span-6">
                        <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">Developer License No.</h2>
                        <TextInput
                            labelTitle
                            fieldLabel="Developer License No."
                            name="developerLicenseNo"
                            value={props.editingProject ? props.editingProject.developerLicenseNo : props.newProject.developerLicenseNo}
                            handleChange={(e) => props.handleChange("developerLicenseNo", e.target.value)}
                            className="border border-gray-300 rounded-lg p-2 w-full"
                        />
                        <ValidationText error={props.validState.error.developerLicenseNo} />
                    </div>

                    <div className="col-span-12 md:col-span-6">
                        <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">Name of Project</h2>
                        <TextInput
                            labelTitle
                            fieldLabel="Name of Project"
                            name="projectName"
                            value={props.editingProject ? props.editingProject.projectName : props.newProject.projectName}
                            handleChange={(e) => props.handleChange("projectName", e.target.value)}
                            className="border border-gray-300 rounded-lg p-2 w-full"
                        />
                        <ValidationText error={props.validState.error.projectName} />
                    </div>

                    <div className="col-span-12 md:col-span-6">
                        <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">Location of Project</h2>
                        <TextInput
                            labelTitle
                            fieldLabel="Location of Project"
                            name="projectLocation"
                            value={props.editingProject ? props.editingProject.projectLocation : props.newProject.projectLocation}
                            handleChange={(e) => props.handleChange("projectLocation", e.target.value)}
                            className="border border-gray-300 rounded-lg p-2 w-full"
                        />
                        <ValidationText error={props.validState.error.projectLocation} />
                    </div>

                    <div className="col-span-12 md:col-span-6">
                        {props.isProjectCompleted == true || props.newProject.isProjectCompleted == true  ? (
                            <>
                                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                                    Date of TOP
                                </h2>
                                <DatePicker
                                    labelTitle
                                    fieldLabel="Date of Top"
                                    name="dateOfTOP"
                                    value={
                                        props.editingProject?.dateOfTOP
                                            ? moment(props.editingProject.dateOfTOP).format("YYYY-MM-DD")
                                            : props.newProject?.dateOfTOP
                                                ? moment(props.newProject.dateOfTOP).format("YYYY-MM-DD")
                                                : ""
                                    }
                                    handleChange={(e) => props.handleChange("dateOfTOP", e.target.value)}
                                />
                            </>
                        ) : (
                            <>
                                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                                    Expected Launch Date
                                </h2>
                                <DatePicker
                                    labelTitle
                                    fieldLabel="Expected Launch Date"
                                    name="expectedLaunchDate"
                                    value={
                                        props.editingProject?.expectedLaunchDate
                                            ? moment(props.editingProject.expectedLaunchDate).format("YYYY-MM-DD")
                                            : props.newProject?.expectedLaunchDate
                                                ? moment(props.newProject.expectedLaunchDate).format("YYYY-MM-DD")
                                                : ""
                                    }
                                    handleChange={(e) => props.handleChange("expectedLaunchDate", e.target.value)}
                                />
                            </>
                        )}

                        <ValidationText error={props.validState.error.developmentTypeID} />
                    </div>


                    <div className="col-span-12 md:col-span-6">
                        <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">Type of Development</h2>
                        <DropdownSelect
                            labelTitle
                            fieldLabel="Type of Development"
                            name="developmentTypeID"
                            value={props.editingProject ? props.editingProject.developmentTypeID : props.newProject.developmentTypeID}
                            drpIdentity="ProjectDevelopmentTypes"
                            optionArray={props.projectDevelopmentTypes}
                            setFilterParameters={props.setFilterParameters}
                            handleChange={(e) => props.handleChange("developmentTypeID", e.target.value)}
                            className="border border-gray-300 rounded-lg p-2 w-full"
                        />
                        <ValidationText error={props.validState.error.developmentTypeID} />
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-6 w-full pt-16">
                    <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                        <div className="flex items-center justify-between">
                            <button type="button" className="btn btn-cancel px-4 py-2 rounded-lg shadow-md" onClick={props.closeModal}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-theme px-4 py-2 rounded-lg shadow-md bg-red-600 text-white hover:bg-red-700" onClick={() => props.handleSave(props.editingProject ? props.editingProject.id : null)}>
                                {props.editingProject ? "Save Changes" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}

export default AddEditProject;
